/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });
  const updatePrdInCart = (productID, Quantity) => {
    let formData = {
        'updates': {
            [parseInt(productID)]: Quantity
        }
    };
    let info = fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    }).then(response => response.json()).then(data => {
        return data
    }).then(success => {
       setTimeout(function(){
         console.log('product updated in cart');
          document.dispatchEvent(new CustomEvent('theme:cart:reload', {bubbles: true}));
        }, 1000);
    }).catch((error) => {
        console.error('Error:', error);
    });
  }
  
  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
      if(cart.item_count > 0){
        console.log(cart.item_count+" in cart.");
        var cart_total,CartProductList,free_prd_varid,freeprd_threshoold,FreeGiftIncludesInCart,FreeGiftPrice;
        FreeGiftIncludesInCart = false;
        FreeGiftPrice= $('#free_gift_prd_price').val();
        cart_total= (cart.original_total_price)/100;
        CartProductList = cart.items;
        free_prd_varid= parseInt($('#free_gift_prd').val());
        freeprd_threshoold= parseInt($('#free_gift_threshold').val());
        $(CartProductList).each(function(e){
          if(this.variant_id == free_prd_varid){
            FreeGiftIncludesInCart = true;
            //cart_total= cart_total-FreeGiftPrice;
          }
        });
        //console.log("cart_total: "+cart_total+", freeprd_threshoold: "+freeprd_threshoold+", free_prd_varid: "+free_prd_varid);
        if(free_prd_varid && freeprd_threshoold && (cart_total > freeprd_threshoold)){
          console.log('reached: add free product');
          if(FreeGiftIncludesInCart == false){
            updatePrdInCart(free_prd_varid,1);
            //console.log('free product not in cart');
          } 
        } else{
          if(FreeGiftIncludesInCart == true){
            console.log('free product already in cart');
            updatePrdInCart(free_prd_varid,0);
          } 
        }
      } 


    /*** start free shipping bar code **/
     var cartTotal = cart.total_price,
          goals = document.querySelectorAll(".er-sidecart-gamification__goal"),
          freeShippingThreshold = parseFloat($('#sidecart_money').text()) || 50.00;
          //freeShippingThreshold = parseFloat(document.getElementById('sidecart_money').innerText) || 50.00;
          //freeShippingThreshold = 4251; // $42.51 threshold for free shipping, in cents
      // Update the threshold attribute and messages initially
      goals.forEach(goal => {
          goal.setAttribute("threshold_amount", freeShippingThreshold);
      });

      
      // Updating UI based on cart total
      if (cartTotal < freeShippingThreshold) {
          document.querySelector(".er-sidecart-gamification__message--value").innerHTML = "$" + Number((freeShippingThreshold - cartTotal) / 100).toFixed(2);
          document.querySelector(".er-sidecart-gamification__message--goal").innerHTML = "Spend more to get free shipping!";
          document.querySelector(".er-sidecart-gamification__message").classList.remove("hidden");
          document.querySelector(".er-sidecart-gamification__final-message").classList.add("hidden");
          goals.forEach(goal => {
              goal.querySelector(".off-image").classList.remove("hidden");
              goal.querySelector(".on-image").classList.add("hidden");
              goal.querySelector(".er-sidecart-gamification__goal--text").classList.remove("active");
          });
      } else {
          document.querySelector(".er-sidecart-gamification__message").classList.add("hidden");
          document.querySelector(".er-sidecart-gamification__final-message").innerHTML = "Congratulations! You've earned free shipping.";
          document.querySelector(".er-sidecart-gamification__final-message").classList.remove("hidden");
          goals.forEach(goal => {
              goal.querySelector(".off-image").classList.add("hidden");
              goal.querySelector(".on-image").classList.remove("hidden");
              goal.querySelector(".er-sidecart-gamification__goal--text").classList.add("active");
          });
      }
      
  
      // Optional: Update a progress bar or other elements if applicable
      var progressBarPercentage = (cartTotal / freeShippingThreshold) * 100;
      console.log('progressBarPercentage: '+progressBarPercentage);
      if(progressBarPercentage > 100){
        progressBarPercentage= 100;
      }
      document.querySelector(".js-gamification-loading-bar").style.width = progressBarPercentage + "%";
      /*** end free shipping bar code **/

      
    } 
    
    
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  
  /* open cart drawer instead of showing the popdown */
  document.addEventListener('theme:cart:popdown', (e) => {
    const listener = (e) => {
      document.querySelector('[data-drawer="drawer-cart"]').dispatchEvent(
        new CustomEvent('theme:drawer:open', {
          bubbles: false,
        })
      );
      document.removeEventListener('theme:cart:change', listener);
    };
    document.addEventListener('theme:cart:change', listener);
  });
  /* open cart drawer instead of showing the popdown */
  
})();


$(document).ready(function(){
   /* custom mega menu */
  $(".mega_menu .category-item").on("mouseover", function () {
    $(".mega_menu .category-item").removeClass('is-active');
    $(this).addClass('is-active');
    
    var title = $(this).attr('data-menu-title');
    $(".category-links").removeClass('is-active');
    $('.category-links[data-menu="'+title+'"]').addClass('is-active');
  });
  /* custom mega menu */

  $(document).on("click", ".collection__nav.small--hide button.sidebar__heading", function(e) {
    e.preventDefault();
    const control = $(this).attr('aria-controls');
    $('.collection__nav.small--hide #'+control).first().toggle();
    $(this).find('.sidebar__heading-chevron').toggleClass('active');
  });

  $(document).on("click", ".collection__nav.small--show button.sidebar__heading", function(e) {
    e.preventDefault();
    const control = $(this).attr('aria-controls');
    $('.collection__nav.small--show #'+control).first().toggle();
    $(this).find('.sidebar__heading-chevron').toggleClass('active');
  });
  
});


//collapsible button
$('[is="toggle-button"]').on('click', (e) => {
    let isAriaExpanded = $(e.target).attr('aria-expanded');
    console.log($(e.target))
    if (isAriaExpanded == 'true') {
        $(e.target).attr('aria-expanded', 'false');
        $(e.target).next('.collapsible').attr('open', null);
    } else {
        $(e.target).attr('aria-expanded', 'true');
        $(e.target).next('.collapsible').attr('open', 'true');
    }
    
});


// store locator 

$(document).ready(function(){
  if (window.location.pathname.replace('/', '') === 'apps/store-locator') {
      setTimeout(() => {
        $('[id*=search_filter_]').first().trigger('click');
        setTimeout(() => $('[id*=search_filter_]').first().trigger('click'), 1000);
      }, 1000);
  }
});
